import useFetch from "../../global/hooks/useFetch";
import useMutation from "../../global/hooks/useMutation";

export const useExpenses = (page = 1, pageSize = 10) => {
  const { data, loading, refetch } = useFetch(
    `/expenses/?page=${page}&page_size=${pageSize}`,
  );
  const {
    mutate: createExpenseMutation,
    loading: creating,
    error: createError,
  } = useMutation("/expenses/", "POST");

  const createExpense = async (expenseData) => {
    const createdExpense = await createExpenseMutation(expenseData);
    await refetch();
    return createdExpense;
  };

  return {
    expenses: data?.results || [],
    pagination: {
      count: data?.count || 0,
      next: data?.next,
      previous: data?.previous,
    },
    loading,
    createExpense,
    creating,
    createError,
    refetch,
  };
};

export const useDeleteExpense = () => {
  const deleteExpense = async (expenseId) => {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(
      `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/expenses/${expenseId}/`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || "Failed to delete expense");
    }

    return true;
  };

  return {
    deleteExpense,
    deleting: false,
    deleteError: null,
  };
};

export const useExpense = (expenseId) => {
  const {
    data: expense,
    loading,
    refetch,
  } = useFetch(`/expenses/${expenseId}/`);
  const {
    mutate: updateExpenseMutation,
    loading: updating,
    error: updateError,
  } = useMutation(`/expenses/${expenseId}/`, "PUT");
  const {
    mutate: deleteExpenseMutation,
    loading: deleting,
    error: deleteError,
  } = useMutation(`/expenses/${expenseId}/`, "DELETE");

  const updateExpense = async (expenseData) => {
    const updatedExpense = await updateExpenseMutation(expenseData);
    await refetch();
    return updatedExpense;
  };

  const deleteExpense = async () => {
    await deleteExpenseMutation();
    return true;
  };

  return {
    expense,
    loading,
    updateExpense,
    updating,
    updateError,
    deleteExpense,
    deleting,
    deleteError,
    refetch,
  };
};
